import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { theme } from '../theme';
import {
  TERMOS_USO,
  POLITICA_PRIVACIDADE,
  TERMOS_VERSAO,
  PRIVACIDADE_VERSAO,
  ULTIMA_ATUALIZACAO,
  EMPRESA,
} from './consentContent';

/**
 * Páginas legais públicas — sem login.
 *
 * POR QUE PRECISAM SER PÚBLICAS: as lojas exigem uma URL de política de
 * privacidade acessível a qualquer pessoa, inclusive ao revisor, que não tem
 * conta. Hoje o mesmo conteúdo só aparecia no modal de consentimento, atrás do
 * login — o que não serve para o formulário da Play nem da App Store.
 *
 * O conteúdo vem de consentContent.js, que é a mesma fonte usada no aceite
 * dentro do app. Duplicar o texto criaria duas versões que divergem com o
 * tempo, e a usuária teria aceitado uma coisa diferente da publicada.
 */

const estiloTexto = {
  whiteSpace: 'pre-wrap',
  fontSize: 14,
  lineHeight: 1.7,
  color: theme.colors.text,
};

export default function PaginasLegais() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const ehPrivacidade = pathname.startsWith('/privacidade');

  const titulo = ehPrivacidade ? 'Política de Privacidade' : 'Termos de Uso';
  const corpo = ehPrivacidade ? POLITICA_PRIVACIDADE : TERMOS_USO;
  const versao = ehPrivacidade ? PRIVACIDADE_VERSAO : TERMOS_VERSAO;

  // No app nao existe botao de voltar do navegador, e no iPhone nao existe nem o
  // do sistema. Quem chega aqui pela tela de assinatura — inclusive o revisor da
  // App Store conferindo os links exigidos — ficava sem saida obvia: so o logo,
  // que leva para a home. `-1` volta para exatamente onde a pessoa estava.
  const voltar = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/');
  };

  return (
    <div className="pagina-publica" style={{ minHeight: '100vh', background: theme.colors.bg, paddingLeft: 16, paddingRight: 16 }}>
      <div style={{ maxWidth: 760, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 24 }}>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <img src="/metria-logo.svg" alt="Metria" style={{ height: 28 }} />
          </Link>
          <button
            type="button"
            onClick={voltar}
            style={{
              background: 'none', border: 'none', cursor: 'pointer', padding: 8,
              color: theme.colors.primary, fontSize: 14, fontWeight: 600,
            }}
          >
            ← Voltar
          </button>
        </div>

        <div style={{
          background: theme.colors.bgCard, borderRadius: 16, padding: '28px 24px',
          border: `1px solid ${theme.colors.border}`,
        }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: theme.colors.text, margin: '0 0 4px' }}>
            {titulo}
          </h1>
          <p style={{ fontSize: 12, color: theme.colors.textMuted, margin: '0 0 20px' }}>
            Versão {versao} · Atualizada em {ULTIMA_ATUALIZACAO}
          </p>

          <div style={estiloTexto}>{corpo}</div>

          <hr style={{ border: 0, borderTop: `1px solid ${theme.colors.borderLight}`, margin: '24px 0 16px' }} />

          <p style={{ fontSize: 12, color: theme.colors.textSecondary, lineHeight: 1.6, margin: 0 }}>
            {EMPRESA.nome} · CNPJ {EMPRESA.cnpj}<br />
            {EMPRESA.endereco}<br />
            {EMPRESA.email}
          </p>

          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 20, fontSize: 13 }}>
            <Link to={ehPrivacidade ? '/termos' : '/privacidade'}>
              {ehPrivacidade ? 'Termos de Uso' : 'Política de Privacidade'}
            </Link>
            <Link to="/excluir-conta">Excluir minha conta</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
